module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"translucency":"データ濃色","mapDisplay":"地図表示","feature-0":"河川","feature-1":"流域界","feature-2":"行政界","feature-3":"洪水浸水想定区域\\n(想定最大規模)","feature-4":"洪水浸水想定区域\\n(計画規模)"},"en":{"translucency":"Translucency","mapDisplay":"Map display","feature-0":"River","feature-1":"Watershed","feature-2":"Administrative District","feature-3":"洪水浸水想定区域\\n(想定最大規模)","feature-4":"洪水浸水想定区域\\n(計画規模)"}}')
  delete Component.options._Ctor
}
